import { ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export abstract class InputFocusAbstractService {
  abstract inputsOnDom$: BehaviorSubject<number>;
  abstract agentInputsOnDom$: BehaviorSubject<number>;

  abstract resetTotalInputsBuilt(): void;
  abstract emitInputIsSet(el?: ElementRef): void;
  abstract emitAgentInputIsSet(el?: ElementRef): void;
}
